import React, { useState } from "react";
import { Tabs } from "antd";
import NewChart from "./NewChart";
import ThoughtChart from "./ThoughtChart";

const EmojiChart = ({ orgId, department }) => {
  const [activeTab, setActiveTab] = useState("1"); // State to track active tab

  const handleTabChange = (key) => {
    setActiveTab(key); // Update the active tab when it changes
  };

  const items = [
    {
      key: "1",
      label: "Mood Logs",
      children: (
        <NewChart orgId={orgId} tab={activeTab} department={department} />
      ),
    },
    {
      key: "2",
      label: "Thought Logs",
      children: <ThoughtChart orgId={orgId} tab={activeTab} />,
    },
  ];

  return (
    <div className="shadow-metafit-shadow bg-white border rounded-[10px] col-sm-12">
      <div className="text-base font-semibold p-4 vistor-chart">
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={handleTabChange}
          className=""
        >
          {items.map((item) => (
            <Tabs.TabPane key={item.key} tab={item.label}>
              {item.children}
            </Tabs.TabPane>
          ))}
        </Tabs>
      </div>
    </div>
  );
};

export default EmojiChart;
